import { render, staticRenderFns } from "./TDpost.vue?vue&type=template&id=f48f46b4"
import script from "./TDpost.vue?vue&type=script&lang=js"
export * from "./TDpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports